import {DataFormat, RestSession, RestWebService, WebServiceTypes} from "@softvision/webpdf-wsclient-9-typescript";
import PortalDocument from "../document/PortalDocument";
import {Internal} from "../../shared/models/Internal";
import {PortalConverterOperation} from "../../shared/models/PortalConverterOperation";
import {Errors, Result, ResultException} from "@softvision/webpdf-wsclient-9-typescript/lib/exception";
import {PortalConverter} from "../../shared/models/PortalConverter";

export class PortalConverterWebService<T_REST_DOCUMENT extends PortalDocument>
	extends RestWebService<T_REST_DOCUMENT, PortalConverterOperation> {

	/**
	 * Creates a ConverterWebService for the given {@link Session}
	 */
	public constructor(session: RestSession<T_REST_DOCUMENT>) {
		super(session, WebServiceTypes.CONVERTER);
	}

	/**
	 * Get webservice specific operation element to set webservice specific parameters
	 */
	public getOperation(): PortalConverter | undefined {
		return this.getOperationData().converter;
	}

	/**
	 * Sets the web service operation data
	 */
	public setOperation(operationData: PortalConverter): void {
		this.getOperationData().converter = operationData;
	}

	/**
	 * Initialize all substructures, that must be set for this webservice to accept parameters for this
	 * webservice type.
	 */
	protected initOperation(): PortalConverterOperation {
		return PortalConverterOperation.fromJson({
			converter: {}
		});
	}

	protected getWebServiceOptions(): BodyInit {
		let operationData: PortalConverterOperation = this.getOperationData();

		switch (this.getSession().getDataFormat()) {
			case DataFormat.JSON:
				return JSON.stringify(operationData.toJson());
			default:
				throw new ResultException(Result.build(Errors.TO_XML_JSON));
		}
	}

	/**
	 * Returns the {@link Internal} of the current webservice.
	 *
	 * @return the {@link Internal} of the current webservice.
	 */
	public getInternal(): Internal | undefined {
		return this.getOperationData().internal;
	}

	/**
	 * Sets the {@link Internal} of the current webservice.
	 *
	 * @param internal The {@link Internal} of the current webservice.
	 */
	public setInternal(internal: Internal | undefined): void {
		this.getOperationData().internal = internal;
	}
}